<template>
  <div id="home-page">
    <div class="hero w-100">
      <b-container class="h-100 my-5">
        <b-row align-h="center" class="h-100">
          <b-col cols="12" class="mt-5 hero-title"
            >Cabinet d’Orthoptie de l'AURORE</b-col
          >
          <b-col class="hero-button">
            <b-button variant="primary" to="/rendez-vous"
              >Prendre rendez-vous</b-button
            >
          </b-col>
        </b-row>
      </b-container>
    </div>
    <b-container fluid class="mt-5">
      <b-row align-h="center" class="text-center">
        <KeyWord
          v-for="keyword in keywords"
          :key="keyword.keyword"
          :keyword="keyword.keyword"
          :logo="keyword.logo"
          :link="keyword.link"
          >{{ keyword.text }}</KeyWord
        >
      </b-row>
    </b-container>
  </div>
</template>

<script>
import KeyWord from "../components/KeyWord";

export default {
  data() {
    return {
      keywords: [
        {
          keyword: "Dépistage visuel",
          logo: "optometry.svg",
          link: "depistage",
        },
        {
          keyword: "Suivi dans le cadre de difficultés d’apprentissage",
          logo: "design.svg",
          link: "apprentissage",
        },
        {
          keyword: "Vertiges et déséquilibre oculo-vestibulaire",
          logo: "dizzy.svg",
          link: "vertiges",
        },
        {
          keyword: "Prise en charge neurovisuelle",
          logo: "stroke.svg",
          link: "neurovisuelle",
        },
        {
          keyword: "Examen de vue",
          text: "Prescription ou renouvellement optique",
          logo: "foroptero.svg",
          link: "prescription",
        },
        {
          keyword: "Télémédecine",
          text: "Dépistage de la rétinopathie diabétique",
          logo: "medical-history.svg",
          link: "tele",
        },
        {
          keyword: "Insuffisance de convergence et difficultés accommodatives",
          logo: "convergence.svg",
          link: "convergence",
        },
        {
          keyword: "Strabisme et Amblyopie",
          logo: "cross-arrows.svg",
          link: "strabisme",
        },
        {
          keyword: "Basse vision",
          logo: "vision.svg",
          link: "basse",
        },
      ],
    };
  },
  components: {
    KeyWord,
  },
};
</script>

<style lang="stylus">
/* Import theme colors palette */
@import '../css/palette.styl';

#home-page .hero {
  height: 60vh;
  background-size: cover;
  background-image: url('../assets/main.jpg');
  text-align: center;
}

@media (max-width: 425px) {
  #home-page .hero {
    height: 70vh;
  }
}

#home-page .hero-title {
  color: $titleColor;
  font-family: 'Overpass', sans-serif;
  font-weight: 400;
  font-size: 4rem;
  text-shadow: 1px 1px $accentColor;
}

@media (max-width: 768px) {
  #home-page .hero-title {
    font-size: 3rem;
  }
}

@media (max-width: 425px) {
  #home-page .hero-title {
    font-size: 2rem;
  }
}

#home-page .btn-primary, #home-page .btn-primary:active, #home-page .btn-primary:visited, #home-page .btn-primary:focus {
  background-color: $accentColor;
  border-color: $accentColor;
  color: $titleColor;
}

#home-page .btn-primary:hover {
  background-color: $pastelGreenColor;
  border-color: $accentColor;
  color: white;
}
</style>
